import React from "react";
import { Binoculars } from "react-bootstrap-icons";

const NotFound = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="flex flex-col items-center text-center px-4 max-w-xl">
        <Binoculars size={56} className="text-primary-600" />
        <p className="font-semibold mt-8 mb-8 px-4">
          Sorry, we couldn't find the page you're looking for.
        </p>
      </div>
    </div>
  );
};

export default NotFound;
